"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _DockerPlugin_instances, _DockerPlugin_dockerManager, _DockerPlugin_configurations, _DockerPlugin_iobDockerApi, _DockerPlugin_startDockerManager;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DockerManager = exports.DockerManagerOfOwnContainers = void 0;
const node_fs_1 = require("node:fs");
const json5_1 = __importDefault(require("json5"));
const plugin_base_1 = require("@iobroker/plugin-base");
const DockerManagerOfOwnContainers_1 = __importDefault(require("./lib/DockerManagerOfOwnContainers"));
exports.DockerManagerOfOwnContainers = DockerManagerOfOwnContainers_1.default;
const DockerManager_1 = __importDefault(require("./lib/DockerManager"));
exports.DockerManager = DockerManager_1.default;
const parseDockerCompose_1 = __importDefault(require("./lib/parseDockerCompose"));
const compose2config_1 = require("./lib/compose2config");
const templates_1 = require("./lib/templates");
class DockerPlugin extends plugin_base_1.PluginBase {
    constructor() {
        super(...arguments);
        _DockerPlugin_instances.add(this);
        _DockerPlugin_dockerManager.set(this, null);
        _DockerPlugin_configurations.set(this, []);
        _DockerPlugin_iobDockerApi.set(this, void 0); // ioBroker setting;
    }
    /** Return the Docker configurations that will be managed */
    get configurations() {
        return __classPrivateFieldGet(this, _DockerPlugin_configurations, "f");
    }
    /**
     * Register and initialize Docker
     *
     * @param pluginConfig plugin configuration from config files
     */
    async init(pluginConfig) {
        // Read the instance config
        const instanceObj = (await this.getObject(this.settings.parentNamespace));
        if (!instanceObj) {
            throw new Error(`Cannot find instance object ${this.settings.parentNamespace}`);
        }
        if (!this.settings.adapterDir) {
            // somehow, the adapter used an old plugin-base version. Try to find the adapter directory
            const adapterName = this.settings.parentPackage.name;
            if ((0, node_fs_1.existsSync)(`${__dirname}/../../${adapterName}`)) {
                this.settings.adapterDir = `${__dirname}/../../${adapterName}`;
            }
            else if ((0, node_fs_1.existsSync)(`${__dirname}/../../../${adapterName}`)) {
                this.settings.adapterDir = `${__dirname}/../../../${adapterName}`;
            }
            else if ((0, node_fs_1.existsSync)(`${__dirname}/../../../../${adapterName}`)) {
                this.settings.adapterDir = `${__dirname}/../../../../${adapterName}`;
            }
            else if ((0, node_fs_1.existsSync)(`${__dirname}/../../../../../${adapterName}`)) {
                this.settings.adapterDir = `${__dirname}/../../../../../${adapterName}`;
            }
            else if ((0, node_fs_1.existsSync)(`${__dirname}/../../../../../../${adapterName}`)) {
                this.settings.adapterDir = `${__dirname}/../../../../../../${adapterName}`;
            }
            else {
                throw new Error('Cannot find adapter directory, please update plugin-base package');
            }
        }
        const instance = parseInt(this.settings.parentNamespace.split('.').pop(), 10);
        if (isNaN(instance)) {
            throw new Error(`Cannot find instance number in ${this.settings.parentNamespace}`);
        }
        (0, templates_1.walkTheConfig)(pluginConfig, instanceObj.native, {
            instance,
        });
        // If dockerFiles is specified, read the files and merge them with dockerConfigs
        if (pluginConfig.iobDockerComposeFiles) {
            for (const filePath of pluginConfig.iobDockerComposeFiles) {
                try {
                    const fileContent = (0, node_fs_1.readFileSync)(`${this.settings.adapterDir}/${filePath}`, 'utf-8');
                    let parsed;
                    if (filePath.endsWith('.json')) {
                        try {
                            parsed = JSON.parse(fileContent);
                        }
                        catch (err) {
                            this.log.error(`Cannot parse docker config file ${filePath}: ${err}`);
                        }
                    }
                    else if (filePath.endsWith('.json5')) {
                        try {
                            parsed = json5_1.default.parse(fileContent);
                        }
                        catch (err) {
                            this.log.error(`Cannot parse docker config file ${filePath}: ${err}`);
                        }
                    }
                    else if (filePath.endsWith('.yaml') || filePath.endsWith('.yml')) {
                        try {
                            parsed = (0, parseDockerCompose_1.default)(fileContent);
                        }
                        catch (err) {
                            this.log.error(`Cannot parse docker config file ${filePath}: ${err}`);
                        }
                    }
                    else {
                        this.log.warn(`Unknown file extension of docker config file ${filePath}`);
                    }
                    if (parsed) {
                        const pureFileConfig = (0, templates_1.walkTheConfig)(parsed, instanceObj.native, {
                            instance,
                        });
                        this.log.debug(`Rendered docker-compose file for docker ${filePath}: ${JSON.stringify(pureFileConfig)}`);
                        const configs = (0, compose2config_1.composeToContainerConfigs)(pureFileConfig);
                        for (const config of configs) {
                            if (config.iobEnabled) {
                                this.log.debug(`Use following config for docker ${filePath}: ${JSON.stringify(config)}`);
                                __classPrivateFieldGet(this, _DockerPlugin_configurations, "f").push(config);
                            }
                        }
                    }
                }
                catch (err) {
                    this.log.error(`Cannot read docker config file ${filePath}: ${err}`);
                }
            }
        }
        if (!__classPrivateFieldGet(this, _DockerPlugin_configurations, "f").length) {
            this.log.debug('No Docker containers to manage');
            return;
        }
        // If any container has iobDockerApi, we need to read available docker configurations
        if (pluginConfig.iobDockerApi && typeof pluginConfig.iobDockerApi === 'string') {
            // If iobDockerApi is a string, we need to read the system.docker object
            const systemDockerObj = await this.getObject('system.docker');
            const nativeConfig = systemDockerObj === null || systemDockerObj === void 0 ? void 0 : systemDockerObj.native;
            if (nativeConfig) {
                // Replace all iobDockerApi strings with actual config objects
                // fallback to the local socket if no system.docker object
                if (!nativeConfig.hosts[pluginConfig.iobDockerApi]) {
                    this.log.warn(`Cannot find docker configuration for ${pluginConfig.iobDockerApi}`);
                    delete pluginConfig.iobDockerApi;
                }
                else {
                    pluginConfig.iobDockerApi = nativeConfig.hosts[pluginConfig.iobDockerApi];
                }
            }
            else {
                this.log.warn('Cannot find system.docker object, but at least one container requires it. Will use local socket');
                delete pluginConfig.iobDockerApi;
            }
        }
        if (typeof pluginConfig.iobDockerApi === 'object') {
            __classPrivateFieldSet(this, _DockerPlugin_iobDockerApi, pluginConfig.iobDockerApi, "f");
        }
        if (!__classPrivateFieldGet(this, _DockerPlugin_configurations, "f").find(conf => conf.iobWaitForReady)) {
            await __classPrivateFieldGet(this, _DockerPlugin_instances, "m", _DockerPlugin_startDockerManager).call(this);
        }
    }
    /**
     * Return the DockerManager object. This can be used to monitor containers
     */
    getDockerManager() {
        return __classPrivateFieldGet(this, _DockerPlugin_dockerManager, "f");
    }
    /**
     * This function will be called when the instance prepared all data to be copied to volume.
     * It should be only called if any container has a flag "iobWaitForReady"
     *
     * @returns Promise which will be resolved when all containers are ready (or immediate if no container has the flag
     */
    async instanceIsReady(forceRestartOfExistingContainer) {
        await __classPrivateFieldGet(this, _DockerPlugin_instances, "m", _DockerPlugin_startDockerManager).call(this, forceRestartOfExistingContainer);
    }
}
_DockerPlugin_dockerManager = new WeakMap(), _DockerPlugin_configurations = new WeakMap(), _DockerPlugin_iobDockerApi = new WeakMap(), _DockerPlugin_instances = new WeakSet(), _DockerPlugin_startDockerManager = async function _DockerPlugin_startDockerManager(forceRestartOfExistingContainer) {
    if (__classPrivateFieldGet(this, _DockerPlugin_configurations, "f").find(conf => conf.iobEnabled !== false)) {
        __classPrivateFieldSet(this, _DockerPlugin_dockerManager, __classPrivateFieldGet(this, _DockerPlugin_dockerManager, "f") || new DockerManagerOfOwnContainers_1.default({
            dockerApi: __classPrivateFieldGet(this, _DockerPlugin_iobDockerApi, "f"),
            logger: {
                level: 'silly',
                silly: this.log.silly.bind(this.log),
                debug: this.log.debug.bind(this.log),
                info: this.log.info.bind(this.log),
                warn: this.log.warn.bind(this.log),
                error: this.log.error.bind(this.log),
            },
            adapterDir: this.settings.adapterDir,
            namespace: this.parentNamespace.replace('system.adapter.', ''),
            forceRestart: forceRestartOfExistingContainer,
        }, __classPrivateFieldGet(this, _DockerPlugin_configurations, "f")), "f");
        await __classPrivateFieldGet(this, _DockerPlugin_dockerManager, "f").isReady();
    }
};
exports.default = DockerPlugin;
